require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./research-from-tumor-dependencies-to-prescription-drugs-personalized-therapeutic-matching-through-functional-genomics.json") })
        }
      }, "path---research-from-tumor-dependencies-to-prescription-drugs-personalized-therapeutic-matching-through-functional-genomics");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---research-from-tumor-dependencies-to-prescription-drugs-personalized-therapeutic-matching-through-functional-genomics!./.cache/json/research-from-tumor-dependencies-to-prescription-drugs-personalized-therapeutic-matching-through-functional-genomics.json
// module id = 487
// module chunks = 231608221292675